import React, { useEffect, useState } from 'react';
import { Skeleton } from 'antd';
import { Pie } from '@ant-design/plots';
import { getHottestSellingPlan } from 'api-services/reporting';

const PlansPieChart = () => {
  const [data, setData] = useState([]);
  const [skeleton, setSkeleton] = useState(true);

  useEffect(()=>{
    const fetchHottestSellingPlan = async () => {
      setSkeleton(true);
      const response = await getHottestSellingPlan();
      if (response.status === 200) {
        const data = response.data.map(({plan, count})=>{
          return {
            plan,
            count: parseInt(count, 10)
          };
        });
        setData(data);
      }
      setSkeleton(false);
    };

    fetchHottestSellingPlan();
  }, []);
  
  const config = {
    appendPadding: 10,
    data,
    angleField: 'count',
    colorField: 'plan',
    radius: 0.9,
    label: {
      type: 'inner',
      offset: '-30%',
      content: ({ percent }) => `${(percent * 100).toFixed(0)}%`,
      style: {
        fontSize: 14,
        textAlign: 'center',
      },
    },
    interactions: [
      {
        type: 'element-active',
      },
    ],
  };

  
  return skeleton?(
    <Skeleton active />
  ):(
    <Pie {...config} />
  );
};

export default PlansPieChart;
